import React from 'react';

interface StorageIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const StorageIcon: React.FC<StorageIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <g clipRule="evenodd" fill={props.fill ?? '#B5BCC4'} fillRule="evenodd">
        <path d="M4.366 3.31a1.056 1.056 0 0 0-1.057 1.056v11.268a1.056 1.056 0 0 0 1.057 1.056h11.267a1.056 1.056 0 0 0 1.056-1.056v-9.05L13.415 3.31h-9.05Zm-1.91-.853a2.7 2.7 0 0 1 1.91-.79h9.39c.217 0 .426.086.58.24l3.756 3.756c.154.154.24.363.24.581v9.39a2.7 2.7 0 0 1-2.699 2.7H4.366a2.7 2.7 0 0 1-2.7-2.7V4.366a2.7 2.7 0 0 1 .79-1.909Z" />
        <path d="M8.09 9.969a2.7 2.7 0 1 1 3.818 3.818A2.7 2.7 0 0 1 8.09 9.969Zm1.91.853a1.056 1.056 0 1 0 0 2.112 1.056 1.056 0 0 0 0-2.112ZM6.243 1.667c.454 0 .822.367.822.821v2.934h3.99V2.488a.822.822 0 1 1 1.644 0v3.756a.822.822 0 0 1-.822.822H6.243a.822.822 0 0 1-.821-.822V2.488c0-.454.368-.821.821-.821Z" />
      </g>
    </svg>
  );
};
